// Data Synchronization Service
// Handles syncing data between mobile and web platforms

import MobileDataService from './mobileDataService';

class DataSyncService {
  private static instance: DataSyncService;
  private syncInterval: NodeJS.Timeout | null = null;
  private lastSyncTime: string = '';

  private constructor() {}

  public static getInstance(): DataSyncService {
    if (!DataSyncService.instance) {
      DataSyncService.instance = new DataSyncService();
    }
    return DataSyncService.instance;
  }

  // Start automatic sync every 30 seconds
  public startAutoSync() {
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
    }

    this.syncInterval = setInterval(() => {
      this.syncData();
    }, 30000); // 30 seconds
  }

  // Stop automatic sync
  public stopAutoSync() {
    if (this.syncInterval) {
      clearInterval(this.syncInterval);
      this.syncInterval = null;
    }
  }

  // Manual sync
  public async syncData() {
    try {
      const dataService = MobileDataService.getInstance();
      
      // Get current data
      const currentData = dataService.exportData();
      const currentTime = new Date().toISOString();
      
      // Check if we have data in localStorage (from web app)
      if (typeof window !== 'undefined' && window.localStorage) {
        const webData = localStorage.getItem('sharedData');
        const webSyncTime = localStorage.getItem('lastSyncTime');
        
        if (webData && webSyncTime) {
          // Parse web data
          const webDataParsed = JSON.parse(webData);
          
          // Check if web data is newer
          if (webSyncTime > this.lastSyncTime) {
            console.log('Syncing from web app data...');
            dataService.importData(webData);
            this.lastSyncTime = webSyncTime;
          } else if (currentTime > webSyncTime) {
            // Mobile data is newer, update web
            console.log('Syncing to web app...');
            localStorage.setItem('sharedData', currentData);
            localStorage.setItem('lastSyncTime', currentTime);
            this.lastSyncTime = currentTime;
          }
        } else {
          // No web data, initialize web with mobile data
          localStorage.setItem('sharedData', currentData);
          localStorage.setItem('lastSyncTime', currentTime);
          this.lastSyncTime = currentTime;
        }
      }
      
      console.log('Data sync completed');
    } catch (error) {
      console.error('Error syncing data:', error);
    }
  }

  // Force sync from web to mobile
  public async syncFromWeb() {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        const webData = localStorage.getItem('sharedData');
        const webSyncTime = localStorage.getItem('lastSyncTime');
        
        if (webData && webSyncTime) {
          const dataService = MobileDataService.getInstance();
          dataService.importData(webData);
          this.lastSyncTime = webSyncTime;
          console.log('Synced from web app');
          return true;
        }
      }
      return false;
    } catch (error) {
      console.error('Error syncing from web:', error);
      return false;
    }
  }

  // Force sync from mobile to web
  public async syncToWeb() {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        const dataService = MobileDataService.getInstance();
        const currentData = dataService.exportData();
        const currentTime = new Date().toISOString();
        
        localStorage.setItem('sharedData', currentData);
        localStorage.setItem('lastSyncTime', currentTime);
        this.lastSyncTime = currentTime;
        console.log('Synced to web app');
        return true;
      }
      return false;
    } catch (error) {
      console.error('Error syncing to web:', error);
      return false;
    }
  }

  // Get sync status
  public getSyncStatus() {
    return {
      lastSyncTime: this.lastSyncTime,
      isAutoSyncActive: this.syncInterval !== null
    };
  }
}

export default DataSyncService;




